<template>
  <section class="h-72 overflow-auto">
    <div v-if="data && data.length" v-click-outside="handleOutside">
      <div
        v-for="d in data"
        :key="d.id"
        class="ring-1 ring-gray-200 px-4 py-3 mb-4 rounded"
      >
        <div class="">
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <Avatar
                :classStr="'h-8 w-8 mr-2'"
                :src="baseUrlSrc(d.thumbnail_url)"
              />
              <p class="capitalize text-xl text-gray-dark">
                {{ profile.f_name }} {{ profile.l_name }}
              </p>
            </div>
            <div class="flex relative">
              <button
                type="button"
                class="px-2 py-1 focus:outline-none"
                @click="toggleDotsVertical(d.id)"
              >
                <DotsVertical />
              </button>
              <div class="mt-4" v-if="isReportOpen[d.id]">
                <ReportDropdown
                  v-model="isReportOpen"
                  :cat_item_id="d.id"
                  :category_id="posts"
                />
              </div>
            </div>
          </div>
          <p class="text-xs py-1 text-gray-700 mt-4">
            {{ d.body }}
          </p>
          <div class="flex items-center mt-2">
            <div v-if="d.is_liked" class="flex justify-center">
              <button
                @click="handlePostLike(d.id, false)"
                class="text-xs text-gray-dark"
              >
                <HeartFill />
              </button>
            </div>
            <div v-else class="flex justify-center">
              <button
                @click="handlePostLike(d.id, true)"
                class="text-xs text-gray-dark"
              >
                <Heart />
              </button>
            </div>
            <span class="text-xs text-gray-dark mr-4 ml-1">
              {{ d.like_counter }} Likes</span
            >
            <div><Chat /></div>
            <router-link
              :to="{ name: 'UserTrainerPostView', params: { id: d.id } }"
              class="text-xs text-gray-dark ml-1"
              >{{ d.total_comments }} Comments
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div
      class="flex flex-col justify-center items-center text-xl text-gray-700 mt-8 space-y-8"
      v-else
    >
      <img
        :src="require(`@/assets/img/my_sessions_no_data.svg`)"
        alt="..."
        class="w-72"
      />
      <div
        class="flex flex-col text-lg justify-center items-center text-center"
      >
        <span> Looks like there is nothing here yet.</span>
        <span>Start sharing posts with your followers above.</span>
      </div>
    </div>
  </section>
</template>

<script>
import { Avatar } from "@/components/t-components";
import { Chat, Heart, HeartFill, DotsVertical } from "@/components/icons";
import { mapActions, mapGetters } from "vuex";
import ReportDropdown from "@/components/report/ReportDropdown";
import ClickOutside from "vue-click-outside";

export default {
  name: "UserPostList",
  components: {
    Avatar,
    Chat,
    Heart,
    HeartFill,
    DotsVertical,
    ReportDropdown,
  },
  props: {
    data: Array,
    handlePostLike: Function,
  },
  data() {
    return {
      profile: [],
      posts: 3,
      isReportOpen: [],
    };
  },
  computed: {
    ...mapGetters(["trainerDetail"]),
  },
  methods: {
    ...mapActions(["getTrainerDetail", "postCommentLike"]),

    toggleDotsVertical(id) {
      var obj = {};
      obj[id] = !this.isReportOpen[id];
      this.isReportOpen = obj;
    },

    handleOutside() {
      this.isReportOpen = false;
    },
  },
  async created() {
    await this.getTrainerDetail(this.$route.params.trainer_id);
    this.profile = this.trainerDetail.profile;
  },
  directives: {
    ClickOutside,
  },
};
</script>